import GalleryElementMetaData from '../GalleryElement/GalleryElementMetaData';

export default {
  type: 'editor.elements.MobileGalleryElement',
  name: 'Gallery',
  icon: GalleryElementMetaData.icon,
  order: 50
};
